module.exports = __webpack_public_path__ + "img/fieldJoin.a0a4c292.png";